import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { API_BASE_URL } from "@config/config";

const fetchCinemas = async () => {
    const res = await axios.get(`${API_BASE_URL}/venue/get-subscriber-cinemas`);
    const list = Array.isArray(res?.data?.data) ? res.data.data : [];
    return list;
};

export const useCinemas = () => {
    const { data, isLoading } = useQuery({
        queryKey: ["cinemas"],
        queryFn: fetchCinemas,
        staleTime: Infinity,
    });

    return {
        cinemas: data ?? [],
        cinemasLoading: isLoading,
    };
};
